"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
var set_version_1 = require("@fluentui/set-version");
set_version_1.setVersion('@fluentui/react-hooks', '8.6.24');
//# sourceMappingURL=version.js.map